<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('company.create_edit_modal.title')"
    class="create-edit-modal"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-form class="create-edit-form" :model="form" :rules="rules" ref="form">
        <upload />
        <div class="form-row">
          <elsa-input
            name="name"
            :label="$t('company.create_edit_modal.name_field.label')"
            :placeholder="$t('company.create_edit_modal.name_field.placeholder')"
            v-model.lazy="form.name"
          >
           {{ $t('company.create_edit_modal.name_field.label') }}
          </elsa-input>
          <elsa-input
            name="username"
            :label="$t('company.create_edit_modal.username_field.label')"
            :placeholder="$t('company.create_edit_modal.username_field.placeholder')"
            v-model.lazy="form.username"
          >
            {{ $t('company.create_edit_modal.username_field.label') }}
          </elsa-input>
        </div>
        <div class="form-row">
          <elsa-select
            name="industry"
            :label="$t('company.create_edit_modal.industry_field.label')"
            :placeholder="$t('company.create_edit_modal.industry_field.placeholder')"
            :options="companyIndustry"
            v-model.lazy="form.industry"
          />

          <elsa-select
            name="companyType"
            :label="$t('company.create_edit_modal.type_field.label')"
            :placeholder="$t('company.create_edit_modal.type_field.placeholder')"
            :options="companyTypes"
            v-model.lazy="form.companyType"
          />
        </div>
        <div class="form-row single address-row">
          <elsa-input
            name="address"
            :label="$t('company.create_edit_modal.address_field.label')"
            :placeholder="$t('company.create_edit_modal.address_field.placeholder')"
            v-model.lazy="form.address1"
          >
            {{ $t('company.create_edit_modal.address_field.label') }}
          </elsa-input>
          <elsa-input
            name="address2"
            v-model.lazy="form.address2"
          >
          </elsa-input>
        </div>
        <div class="form-row">
          <elsa-input
            name="city"
            :label="$t('company.create_edit_modal.city_field.label')"
            :placeholder="$t('company.create_edit_modal.city_field.placeholder')"
            v-model.lazy="form.city"
          >
            {{ $t('company.create_edit_modal.city_field.label') }}
          </elsa-input>

          <elsa-input
            name="state"
            :label="$t('company.create_edit_modal.state_field.label')"
            :placeholder="$t('company.create_edit_modal.state_field.placeholder')"
            v-model.lazy="form.state"
          >
            {{ $t('company.create_edit_modal.state_field.label') }}
          </elsa-input>

          <elsa-input
            name="postcode"
            type="number"
            :label="$t('company.create_edit_modal.post_code_field.label')"
            :placeholder="$t('company.create_edit_modal.post_code_field.placeholder')"
            v-model.lazy="form.postcode"
          >
            {{ $t('company.create_edit_modal.post_code_field.label') }}
          </elsa-input>
        </div>
        <div class="form-row">
          <country-select
            name="country"
            :label="$t('company.create_edit_modal.country_field.label')"
            :placeholder="$t('company.create_edit_modal.country_field.placeholder')"
            v-model="form.country"
          />
          <div class="phone-wrapper">
            <country-select
              name="phoneCode"
              :label="$t('company.create_edit_modal.phone_field.label')"
              :placeholder="$t('company.create_edit_modal.phone_field.code')"
              v-model="form.phone_code"
              type="phone"
            />
            <elsa-input
              name="phone"
              type="number"
              :placeholder="$t('company.create_edit_modal.phone_field.placeholder')"
              v-model.lazy="form.phone_number"
            >
              {{ $t('company.create_edit_modal.phone_field.label') }}
            </elsa-input>
          </div>
        </div>
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        @click.native="handleSave"
      >
        {{ $t('company.create_edit_modal.create') }}
      </primary-button>
      <tertiary-button @click.native="handleCancelClick">
        {{ $t('company.create_edit_modal.cancel') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import Upload from '@/components/common/Upload'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import ElsaSelect from '@/components/common/Select'
  import CountrySelect from '@/components/common/CountrySelect'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  export default {
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton,
      Upload,
      ElsaInput,
      ElsaSelect,
      CountrySelect
    },
    data() {
      return {
        form: {},
        value: '',
        rules: {
          name: { required: true, message: this.$t('company.create_edit_modal.name_field.validation_msg'), trigger: 'blur' },
          username: { required: true, message: this.$t('company.create_edit_modal.username_field.validation_msg'), trigger: 'blur' },
          companyType: { required: true, message: this.$t('company.create_edit_modal.type_field.validation_msg'), trigger: 'blur' },
          industry: { required: true, message: this.$t('company.create_edit_modal.industry_field.validation_msg'), trigger: 'blur' },
          address: { required: true, message: this.$t('company.create_edit_modal.address_field.validation_msg'), trigger: 'blur' },
          phoneCode: { required: true, message: this.$t('company.create_edit_modal.phone_field.code_validation_msg'), trigger: 'blur' },
          phone: { type: 'number', message: this.$t('company.create_edit_modal.phone_field.validation_msg'), trigger: 'blur' },
          country: { required: true, message: this.$t('company.create_edit_modal.country_field.validation_msg'), trigger: 'blur' },
          state: { required: true, message: this.$t('company.create_edit_modal.state_field.validation_msg'), trigger: 'blur' },
          city: { required: true, message: this.$t('company.create_edit_modal.city_field.validation_msg'), trigger: 'blur' },
          postcode: [
            { required: true, message: this.$t('company.create_edit_modal.post_code_field.required_validation_msg'), trigger: 'blur' },
            { type: 'number', message: this.$t('company.create_edit_modal.post_code_field.number_validation_msg'), trigger: 'blur' }
          ]
        },
        companyTypes: [
          {
            label: this.$t('company.create_edit_modal.company_type.youtube_type_1'),
            value: 'type-1'
          },
          {
            label: this.$t('company.create_edit_modal.company_type.youtube_type_2'),
            value: 'type-2'
           }
        ],
        companyIndustry: [
          {
            label: this.$t('company.create_edit_modal.company_type.youtube_industry_1'),
            value: 'industry-1'
          },
          {
            label: this.$t('company.create_edit_modal.company_type.youtube_industry_2'),
            value: 'industry-2'
          }
        ],
      }
    },
    methods: {
      handleSave() {
        this.$emit('closed', 'company')
      },
      handleCancelClick() {
        this.$emit('closed')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
